module.exports = "<div class=\"box-border-down\">\n    MESSAGE OUTBOUND\n</div>\n\n";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/services/messageOutbound/messageOutbound.html
 ** module id = 521
 ** module chunks = 0
 **/